import { Draft } from "@utils/Draft.util";
import { IContactAndBilling } from "@models/EventRegistrationForm.model";
import { getDefaultPhoneCodeUtil } from "./getDefaultPhoneCode.util";

export const contactAndBillingDraftToInitialValues = (
  draft: Draft<IContactAndBilling>,
  ls: string
): Draft<IContactAndBilling> => ({
  name: draft.name,
  lastName: draft.lastName,
  firstName: draft.firstName,
  address: draft.address || { phone: { code: getDefaultPhoneCodeUtil(ls) } },
  billingAddress: draft.billingAddress || {
    phone: { code: getDefaultPhoneCodeUtil(ls) },
  },
  isBillingAddressSame:
    draft.isBillingAddressSame === undefined
      ? true
      : draft.isBillingAddressSame,
});
